import { css } from 'linaria';

export const catalogTabs = css`
  && {
    margin: 0;
    margin-bottom: 48px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }

    @media (--only-largeDesktop) {
      .swiper {
        padding-right: calc((96vw - 1180px) / 2);
        padding-left: calc((96vw - 1180px) / 2);
        margin-right: calc((-96vw + 1180px) / 2);
        margin-left: calc((-96vw + 1180px) / 2);
      }
    }

    button {
      @media (--only-mobile) {
        padding: 9px 20px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const catalogGroupIcon = css`
  display: block;
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: 8px;

  @media (--only-mobile) {
    width: 40px;
    height: 40px;
    margin-right: 16px;
    margin-bottom: 0;
  }
`;

export const catalogItem = css`
  width: 356px;

  @media (--only-desktop) {
    width: 276px;
  }

  @media (--only-tablet) {
    width: 298px;
  }

  @media (--only-mobile) {
    width: 100%;

    &:active {
      background-color: var(--background-secondary);
    }
  }

  @media (--from-tablet) {
    :hover {
      color: var(--brand-dark);
    }
  }
`;

export const catalogItemName = css`
  width: 100%;
  height: 100%;
  padding: 8px 0;

  @media (--only-mobile) {
    padding: 12px 0;
    padding-left: 56px;
  }
`;
